import BlockRoundedIcon from "@mui/icons-material/BlockRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import payaLogo from "src/Assets/Images/payaLogo.png";
import Button from "src/Components/Button";
import { logout } from "src/Requests/authRequests";
import { clearAuthStorage, isCustomerUser } from "src/helper";

const ForbiddenAccess = () => {
  const navigate = useNavigate();
  const isCustomer = isCustomerUser();

  const logoutHandler = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      clearAuthStorage();
      navigate("/");
      return;
    }
    logout(token)
      .then(() => {
        clearAuthStorage();
        navigate("/");
      })
      .catch(() => toast.error("عدم ارتباط با سرور"));
  };

  return (
    <div className="min-h-[70vh] w-full flex flex-col justify-center items-center px-4 py-10">
      <div className="w-full max-w-md bg-white border-2 border-sky-600 shadow-lg rounded-xl p-8 flex flex-col items-center gap-6">
        <img src={payaLogo} alt="پایا الگوریتم" className="w-24 h-24 opacity-90" />

        <div className="flex flex-col items-center gap-3 text-center">
          <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center">
            <BlockRoundedIcon className="!text-4xl !text-red-500" />
          </div>
          <h1 className="text-xl font-bold text-gray-800">
            دسترسی غیرمجاز
          </h1>
          <p className="text-sm text-gray-500 leading-7">
            شما مجوز دسترسی به این صفحه را ندارید.
            {isCustomer
              ? " لطفاً از بخش پورتفو استفاده کنید یا از حساب خود خارج شوید."
              : " لطفاً با مدیر سیستم تماس بگیرید یا دوباره وارد شوید."}
          </p>
        </div>

        <div className="w-full flex flex-col gap-3">
          {isCustomer && (
            <Button
              variant="contained"
              onClick={() => navigate("/iMEPortfolio")}
              text={
                <span className="flex items-center justify-center gap-2">
                  <HomeRoundedIcon className="!text-lg" />
                  بازگشت به پورتفو
                </span>
              }
            />
          )}
          <Button
            variant="outlined"
            onClick={logoutHandler}
            text={
              <span className="flex items-center justify-center gap-2">
                <LogoutRoundedIcon className="!text-lg" />
                خروج از حساب
              </span>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default ForbiddenAccess;
